(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = initialState || this.createEmptyBoard();
        this.score = 0;
        this.status = "playing";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "createEmptyBoard",
            value: function createEmptyBoard() {
                var board = [];
                for(var i = 0; i < 4; i++)board.push([
                    0,
                    0,
                    0,
                    0
                ]);
                return board;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.board[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var row = _step.value;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = row[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var tile = _step1.value;
                                if (tile === 2048) {
                                    this.status = "win";
                                    return "win";
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!this.hasAvailableMoves()) {
                    this.status = "lose";
                    return "lose";
                }
                return "playing";
            }
        },
        {
            key: "hasEmptyCells",
            value: function hasEmptyCells() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = this.board[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var row = _step.value;
                        try {
                            for(var _iterator1 = row[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var tile = _step1.value;
                                if (tile === 0) return true;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "canMerge",
            value: function canMerge() {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    if (i < 3 && this.board[i][j] === this.board[i + 1][j]) return true;
                    if (j < 3 && this.board[i][j] === this.board[i][j + 1]) return true;
                }
                return false;
            }
        },
        {
            key: "hasAvailableMoves",
            value: function hasAvailableMoves() {
                return this.hasEmptyCells() || this.canMerge();
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var row = _this.board[i];
                    var newRow = _this.mergeRow(row);
                    if (newRow.some(function(tile, index) {
                        return tile !== row[index];
                    })) moved = true;
                    _this.board[i] = newRow;
                };
                var moved = false;
                for(var i = 0; i < 4; i++)_loop(i);
                if (moved) this.addRandomTile();
                this.updateUI();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    var row = _this.board[i];
                    var reversedRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                    var newRow = _this.mergeRow(reversedRow);
                    if (newRow.some(function(tile, index) {
                        return tile !== reversedRow[index];
                    })) moved = true;
                    _this.board[i] = newRow.reverse();
                };
                var moved = false;
                for(var i = 0; i < 4; i++)_loop(i);
                if (moved) this.addRandomTile();
                this.updateUI();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(j) {
                    var column = _this.board.map(function(row) {
                        return row[j];
                    });
                    var newColumn = _this.mergeRow(column);
                    for(var i = 0; i < 4; i++)_this.board[i][j] = newColumn[i];
                    if (newColumn.some(function(tile, index) {
                        return tile !== column[index];
                    })) moved = true;
                };
                var moved = false;
                for(var j = 0; j < 4; j++)_loop(j);
                if (moved) this.addRandomTile();
                this.updateUI();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(j) {
                    var column = _this.board.map(function(row) {
                        return row[j];
                    }).reverse();
                    var newColumn = _this.mergeRow(column);
                    for(var i = 0; i < 4; i++)_this.board[i][j] = newColumn[3 - i];
                    if (newColumn.some(function(tile, index) {
                        return tile !== column[index];
                    })) moved = true;
                };
                var moved = false;
                for(var j = 0; j < 4; j++)_loop(j);
                if (moved) this.addRandomTile();
                this.updateUI();
            }
        },
        {
            key: "mergeRow",
            value: function mergeRow(row) {
                var newRow = row.filter(function(tile) {
                    return tile !== 0;
                });
                for(var i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1]) {
                    newRow[i] *= 2;
                    this.score += newRow[i];
                    newRow.splice(i + 1, 1);
                }
                while(newRow.length < 4)newRow.push(0);
                return newRow;
            }
        },
        {
            key: "start",
            value: function start() {
                this.board = this.createEmptyBoard();
                this.score = 0;
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
                this.updateUI();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.start();
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (this.board[i][j] === 0) emptyCells.push([
                        i,
                        j
                    ]);
                }
                if (emptyCells.length === 0) return;
                var randomCell = emptyCells[Math.floor(Math.random() * emptyCells.length)];
                var randomValue = Math.random() < 0.1 ? 4 : 2;
                this.board[randomCell[0]][randomCell[1]] = randomValue;
                // #region animation
                // Trigger 'appear' animation
                var _emptyCells_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[Math.floor(Math.random() * emptyCells.length)], 2), row = _emptyCells_Math_floor[0], col = _emptyCells_Math_floor[1];
                var cellElement = document.querySelector(".game-field tr:nth-child(".concat(row + 1, ") td:nth-child(").concat(col + 1, ")"));
                cellElement.classList.add("appear");
                // remove class after animation
                setTimeout(function() {
                    return cellElement.classList.remove("appear");
                }, 300);
            // #endregion
            }
        },
        {
            key: "updateUI",
            value: function updateUI() {
                var gameStatus = this.getStatus();
                var startMessage = document.querySelector(".message-start");
                var winMessage = document.querySelector(".message-win");
                var loseMessage = document.querySelector(".message-lose");
                startMessage.classList.add("hidden");
                if (gameStatus === "win") {
                    winMessage.classList.remove("hidden");
                    loseMessage.classList.add("hidden");
                } else if (gameStatus === "lose") {
                    loseMessage.classList.remove("hidden");
                    winMessage.classList.add("hidden");
                } else {
                    winMessage.classList.add("hidden");
                    loseMessage.classList.add("hidden");
                }
                document.querySelector(".game-score").textContent = this.score;
                var cells = document.querySelectorAll(".field-cell");
                var cellIndex = 0;
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    var tileValue = this.board[i][j];
                    var cell = cells[cellIndex];
                    cell.classList.remove("field-cell--2", "field-cell--4", "field-cell--8", "field-cell--16", "field-cell--32", "field-cell--64", "field-cell--128", "field-cell--256", "field-cell--512", "field-cell--1024", "field-cell--2048");
                    if (tileValue !== 0) {
                        cell.classList.add("field-cell--".concat(tileValue));
                        cell.textContent = tileValue;
                    } else cell.textContent = "";
                    cellIndex++;
                }
            }
        },
        {
            key: "updateScoreDisplay",
            value: function updateScoreDisplay() {
                var scoreElement = document.querySelector(".score");
                scoreElement.textContent = this.score;
                // Add score update animation
                scoreElement.classList.add("updated");
                // Remove class after animation
                setTimeout(function() {
                    return scoreElement.classList.remove("updated");
                }, 300);
            }
        },
        {
            key: "checkGameStatus",
            value: function checkGameStatus() {
                var statuses = this.getStatus();
                var messageElement = document.querySelector(".game-status");
                if (statuses === "win") messageElement.textContent = "You Win!";
                else if (statuses === "lose") messageElement.textContent = "Game Over!";
                else messageElement.textContent = "Keep Going!";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startButton = document.querySelector("button");
var $197cd56b15c33885$var$gameStarted = false;
function $197cd56b15c33885$var$handleKeyPress(e) {
    if (!$197cd56b15c33885$var$gameStarted) {
        $197cd56b15c33885$var$gameStarted = true;
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
    }
    if (e.key === "ArrowLeft") $197cd56b15c33885$var$game.moveLeft();
    else if (e.key === "ArrowRight") $197cd56b15c33885$var$game.moveRight();
    else if (e.key === "ArrowUp") $197cd56b15c33885$var$game.moveUp();
    else if (e.key === "ArrowDown") $197cd56b15c33885$var$game.moveDown();
    $197cd56b15c33885$var$game.updateScoreDisplay();
    $197cd56b15c33885$var$game.checkGameStatus();
}
document.addEventListener("keydown", $197cd56b15c33885$var$handleKeyPress);
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if (!$197cd56b15c33885$var$gameStarted) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$gameStarted = true;
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$startButton.textContent = "Start";
        $197cd56b15c33885$var$gameStarted = false;
    }
    $197cd56b15c33885$var$startButton.classList.toggle("start");
    $197cd56b15c33885$var$startButton.classList.toggle("restart");
    $197cd56b15c33885$var$game.updateScoreDisplay();
    $197cd56b15c33885$var$game.checkGameStatus();
});

})();
//# sourceMappingURL=index.139e048f.js.map
